<div class="modal-wrapper">
  @if (!forceUpdate) {
    <evs-button (click)="closeModal()" class="closeButton" [buttonData]="{ type: 'navigationButton', iconName: 'Times' }"></evs-button>
  }

  <div class="modal-version-update" [class.non-blocking]="!forceUpdate">
    <div class="modal-body">
      <div class="version-icon">
        <img src="assets/svg/logo-border-shadow.svg" alt="logo-car-only" />
      </div>

      @if (forceUpdate) {
        <div class="modal-header">
          <h2>Une mise à jour s'impose</h2>
        </div>
      }

      <div
        class="version-message"
        [innerHTML]="
          message ||
          'La version de ton app est trop ancienne pour être compatible avec nos dernières fonctionnalité. Fais la mise à jour pour continuer ton expérience !'
        "></div>
    </div>

    <div class="modal-footer">
      <evs-button [buttonData]="{ type: forceUpdate ? 'primaryButton' : 'blackButton', label: ctaName }" (click)="goToStore()"></evs-button>
    </div>
  </div>
</div>
